import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as ReactLink, NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { getQueryString } from '../utils/url';
import { addTrailingSlash } from '../utils/string';
import { omit } from '../utils/object';
import { trackEvent as trackEventAction } from '../actions/tracking';

const EXCLUDE_PROPS = [
  'track',
  'trackEvent',
  'match',
  'location',
  'history',
  'onClick',
  'profile_uuid'
];

const mapStateToProps = ({ session }) => ({
  profile_uuid: session ? session.user : null // eslint-disable-line camelcase
});

const mapDispatchToProps = {
  trackEvent: trackEventAction
};

class Link extends Component {
  handleClick = (e) => {
    const {
      location,
      track,
      trackEvent,
      external,
      onClick,
      history,
      profile_uuid // eslint-disable-line camelcase
    } = this.props;

    const { type } = e;
    const label = e.target.innerText;
    if (!external) {
      // Push the current scrollTop into the react router history state (and the browser's);
      history.replace({ ...location, state: { scrollTop: document.body.scrollTop } });

      // Scroll the page up to the top
      window.scrollTo(0, 0);
    }

    if (track) {
      trackEvent({
        ...track, profile_uuid, label, type
      });
    } // eslint-disable-line camelcase

    if (onClick) onClick(e);
  }

  render() {
    const {
      external, to, children, target, rel, title, className = '', withIcon, ...props
    } = this.props;
    const otherProps = omit(EXCLUDE_PROPS, props);

    const classes = `${className} ${withIcon ? 'with-icon-after' : ''}`;

    if (external) {
      return (
        <a
          href={to}
          onClick={this.handleClick}
          target={target || '_self'}
          rel={rel}
          title={title}
          data-name={props['data-name']}
          className={classes}
        >
          { children }
        </a>
      );
    }

    const linkTo = (typeof to === 'string')
      ? addTrailingSlash(to)
      : { pathname: addTrailingSlash(to.pathname), search: to.search || `?${getQueryString(to.query)}` };

    const Element = props.activeClassName ? NavLink : ReactLink;

    return (
      <Element to={linkTo} onClick={this.handleClick} className={classes} rel={rel} {...otherProps}>
        { children }
      </Element>
    );
  }
}

Link.propTypes = {
  track: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Link));



// WEBPACK FOOTER //
// ./src/universal/ui/components/Link.js